import React from 'react'
import { TextField } from '@material-ui/core'
import { useRecoilState } from 'recoil'
import { chequeSettingsFilterState } from '../recoil/atoms'
const Filter = () => {
    const [filter, setFilter] = useRecoilState(chequeSettingsFilterState);
    const updateFilter = ({ target: { value } }) => {
        setFilter(value);
    };
    return (
        <TextField
            id="search"
            label="جستجو"
            type="search"
            value={filter}
            onChange={updateFilter}
        />
    )
}

export default Filter
